<template>
  <v-row no-gutters>
    <v-col class="pa-0 list-object-images">

      <!-- VIDEO btn -->

      <v-btn
        v-if="object.videoLink"
        class="elevation-0 ml-3 list-video-btn"
        color="grey lighten-4"
        :style="listVideoBtnStyle"
        x-small
        @click="openVideoAndScroll"
      >
        <v-icon
          class="mr-2"
          style="color: #219bc8;"
          x-small
        >
          fa-video
        </v-icon>
        {{ $i18n.t('video') }}
      </v-btn>

      <!-- FAVORITE btn -->

      <div
        :style="listFavoriteToggleBtnStyle"
        class="list-img-btn list-favorite-toggle-btn"
        @click.stop="$store.dispatch('toggleFavorite', object)"
      >
        <i
          :class="isFavorite(object) ? 'fa fa-heart' : 'far fa-heart'"
        />
      </div>

      <!-- RIGHT nav -->

      <div
        v-if="$vuetify.breakpoint.smAndUp"
        class="list-img-btn list-img-nav-btn"
        :style="listImgRightBtnStyle"
        @click.stop="nextObjectListImg()"
      >
        <i class="fa fa-chevron-right" />
      </div>

      <!-- LEFT nav -->

      <div
        v-if="$vuetify.breakpoint.smAndUp"
        class="list-img-btn list-img-nav-btn"
        style="left: 10px; padding: 2px 4px 0px 9px;"
        @click.stop="prevObjectListImg()"
      >
        <i class="fa fa-chevron-left" />
      </div>

      <!-- IMAGES -->

      <router-link
        :to="objectLink(object)"
      >
        <div
          v-if="object.objectImages && object.objectImages[imageIndex]"
          :class="'noselect list-object-img ' + (showListObjectInfoVertically ? 'list-object-img-mobile' : '')"
          :style="showListObjectInfoVertically ? 'background-image: url(\'' + 'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[imageIndex].image + '\');' : ''"
          v-touch="{
            left: () => nextObjectListImg(),
            right: () => prevObjectListImg()
          }"
        >
          <div
            v-if="$vuetify.breakpoint.xsOnly && !hideImgBullets"
            class="compact-bullets bullets-in-list"
          >
            <i class="fas fa-circle" style="font-size: 0.6em;"></i>
            <i class="fas fa-circle" style="font-size: 0.8em;"></i>
            <i class="fas fa-circle"></i>
            <i class="fas fa-circle" style="font-size: 0.8em;"></i>
            <i class="fas fa-circle" style="font-size: 0.6em;"></i>
          </div>
          <img
            v-if="!showListObjectInfoVertically"
            :src="'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[imageIndex].image"
            :width="!showListObjectInfoVertically ? 273 : ''"
            :height="!showListObjectInfoVertically ? 188 : ''"
          >
          <div class="list-preloaded-image">
            <img
              :src="'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[imagePreloadIndex].image"
            >
          </div>
        </div>
      </router-link>
    </v-col>
  </v-row>
</template>

<script>
import sharedComputed from '@/methods/sharedComputed'
import objectMethods from '@/methods/objectMethods'
import sharedMethods from '@/methods/sharedMethods'

export default {
  name: 'ListObjectImages',

  props: {
    object: {
      type: Object,
      default: () => {},
    },
  },

  data () {
    return {
      imageIndex: 0,
      imagePreloadIndex: 1,
      hideImgBullets: false,
    }
  },

  computed: {
    ...sharedComputed,

    listFavoriteToggleBtnStyle () {
      const style = {}
      if (this.showListObjectInfoVertically) {
        style.right = '10px'
      } else {
        style.left = '231px'
      }
      if (this.isFavorite(this.object)) {
        style.color = 'red'
      } else {
        style.color = '#666'
      }
      return style
    },

    listVideoBtnStyle () {
      const style = {}
      if (this.showListObjectInfoVertically) {
        style.left = '0px'
      } else {
        style.left = '0px'
      }
      return style
    },

    listImgRightBtnStyle () {
      const style = {
        padding: '2px 4px 0 10px'
      }
      if (this.showListObjectInfoVertically) {
        style.right = '10px'
      } else {
        style.left = '231px'
      }
      return style
    },
  },

  methods: {
    ...objectMethods,
    ...sharedMethods,

    openVideoAndScroll () {
      this.$router.push({
        path: this.objectLink(this.object)
      })
      setTimeout(() => {
        this.$vuetify.goTo('#video', {
          duration: 1300,
          easing: 'easeInOutCubic',
          offset: 0,
        })
      }, 1000)
    },

    hideBulletsForAMoment () {
      this.hideImgBullets = true
      setTimeout(() => {
        this.hideImgBullets = false
      }, 150)
    },

    nextObjectListImg () {
      this.hideBulletsForAMoment()
      this.imageIndex++
      if (this.imageIndex > this.object.objectImages.length - 1) {
        this.imageIndex = 0
      }
      if (this.imagePreloadIndex < this.object.objectImages.length - 1) {
        this.imagePreloadIndex++
      }
    },

    prevObjectListImg () {
      this.hideBulletsForAMoment()
      this.imageIndex--
      if (this.imageIndex < 0) {
        this.imageIndex = this.object.objectImages.length - 1
      }
    },
  },
}
</script>
